import { Controller } from '@hotwired/stimulus';

export class DrawerController extends Controller {
    declare readonly backdropTarget: HTMLElement;
    declare readonly panelTarget: HTMLElement;

    static targets = ['backdrop', 'overlay', 'panel'];

    connect() {
        document.addEventListener(`ovasai:drawer:open:${this.element.id}`, this.open);
        document.addEventListener(`ovasai:drawer:close:${this.element.id}`, this.close);
    }

    disconnect() {
        this.backdropTarget.classList.remove('transition-opacity');
        this.panelTarget.classList.remove('transition');
        document.removeEventListener(`ovasai:drawer:open:${this.element.id}`, this.open);
        document.removeEventListener(`ovasai:drawer:close:${this.element.id}`, this.close);
    }

    open = (): void => {
        // Show the drawer element first
        this.element.classList.remove('hidden');
        
        // Use timeout to allow browser to render before transition
        setTimeout(() => {
            // Show the backdrop with opacity transition
            this.backdropTarget.classList.remove('opacity-0');
            this.backdropTarget.classList.add('opacity-100');
            this.backdropTarget.classList.remove('pointer-events-none');

            // Show the panel with slide-in transition
            this.panelTarget.classList.remove('translate-x-full');
            this.panelTarget.classList.add('translate-x-0');
        }, 10);
    }

    close = (): void => {
        // Hide the backdrop with opacity transition
        this.backdropTarget.classList.remove('opacity-100');
        this.backdropTarget.classList.add('opacity-0');
        this.backdropTarget.classList.add('pointer-events-none');

        // Hide the panel with slide-out transition
        this.panelTarget.classList.remove('translate-x-0');
        this.panelTarget.classList.add('translate-x-full');

        // Hide the drawer element after panel transition completes
        const handleTransitionEnd = (event: TransitionEvent) => {
            if (event.target === this.panelTarget && event.propertyName === 'transform') {
                this.element.classList.add('hidden');
                this.panelTarget.removeEventListener('transitionend', handleTransitionEnd);
            }
        };
        this.panelTarget.addEventListener('transitionend', handleTransitionEnd);
    }
}
